"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfiguration = {
    AssetTestLowerThresholdCoupleHomeowner: 451500,
    AssetTestLowerThresholdCoupleNonHomeowner: 693500,
    AssetTestUpperThresholdCoupleHomeowner: 986500,
    AssetTestUpperThresholdCoupleNonHomeowner: 1228500,
    AssetTestLowerThresholdSingleHomeowner: 301750,
    AssetTestLowerThresholdSingleNonHomeowner: 543750,
    AssetTestUpperThresholdSingleHomeowner: 656500,
    AssetTestUpperThresholdSingleNonHomeowner: 898500,
    IncomeTestLowerThresholdCouple: 360,
    IncomeTestLowerThresholdSingle: 204,
    IncomeTestUpperThresholdCouple: 3568.00,
    IncomeTestUpperThresholdSingle: 2332.00,
    PensionCouple: 732.3,
    PensionSingle: 971.5,
    PensionSupplementCoupleMaximum: 69.7,
    PensionSupplementCoupleMinimum: 42.4,
    PensionSupplementSingleMaximum: 92.5,
    PensionSupplementSingleMinimum: 56.3,
    DeemingThresholdSingle: 60400,
    DeemingThresholdCouple: 100200,
    DeemingRateLowerIncome: 0.0025,
    DeemingRateHigherIncome: 0.0225,
    CoContributionLowerThreshold: 43445,
    CoContributionUpperThreshold: 58445,
    MaximumContributionBase: 1000,
    CurrentMaximumCoContribution: 500,
    SGCMaximumContributionBase: 62270,
    UntaxedPlanCapAmount: 1705000,
    ConcessionalContributionThreshold: 29471,
    NonConcessionalContributionThreshold: 117884,
    PensionTransferBalanceCap: 1920000,
    LowIncomeEarnersGovernmentContributionIncomeThreshold: 37000,
    LowIncomeEarnersGovernmentContributionMaximum: 500,
    HighIncomeEarningThreshold: 250000,
    WorkBonus: 300,
    IncomeTaxRates: {
        band_0: {
            bandStart: 0,
            rate: 0
        },
        band_1: {
            bandStart: 18200,
            rate: 0.19
        },
        band_2: {
            bandStart: 45000,
            rate: 0.325
        },
        band_3: {
            bandStart: 120000,
            rate: 0.37
        },
        band_4: {
            bandStart: 180000,
            rate: 0.45
        }
    },
    IncomeTaxRates_2022: {
        band_0: {
            bandStart: 0,
            rate: 0
        },
        band_1: {
            bandStart: 18200,
            rate: 0.19
        },
        band_2: {
            bandStart: 45000,
            rate: 0.325
        },
        band_3: {
            bandStart: 120000,
            rate: 0.37
        },
        band_4: {
            bandStart: 180000,
            rate: 0.45
        }
    },
    IncomeTaxRates_2024: {
        band_0: {
            bandStart: 0,
            rate: 0
        },
        band_1: {
            bandStart: 18200,
            rate: 0.19
        },
        band_2: {
            bandStart: 45000,
            rate: 0.3
        },
        band_3: {
            bandStart: 200000,
            rate: 0.45
        }
    },
    MedicareLowerThreshold: 24276,
    MedicareUpperThreshold: 30345,
    MedicarePhasingInRate: 0.1,
    MedicareRate: 0.02,
    LITOLowerThreshold: 37000,
    LITOUpperThreshold: 66666,
    MaximumLITO: 445,
    MaximumLITO_2022: 645,
    LITO_2022_LowIncomeThreshold: 37500,
    LITO_2022_MiddleIncomeThreshold: 45000,
    LITO_2022_HighIncomeThreshold: 66667,
    LITO_2022_MaxPaymentRate: 700,
    LITO_2022_LowPaymentRate: 325,
    LITO_2022_InitialPhaseOutRate: 0.05,
    LITO_2022_SubsequentPhaseOutRate: 0.015,
    LMITO_LowPaymentRate: 255,
    LMITO_MaxPaymentRate: 1080,
    LMITO_LowRateLowIncomeThreshold: 37000,
    LMITO_MaxRateLowIncomeThreshold: 48000,
    LMITO_MaxRateHighIncomeThreshold: 90000,
    LMITO_HighIncomeThreshold: 126000,
    LMITO_PhaseInRate: 0.075,
    LMITO_PhaseOutRate: 0.03,
    MaximumSATO: 2230,
    MaximumSATOCouple: 1602,
    SATOLowerThreshold: 32279,
    SATOLowerThresholdCouple: 28974,
    SATOUpperThreshold: 50119,
    SATOUpperThresholdCouple: 41790,
    UntaxedComponent: 0,
    UntaxedComponent_2: 0,
    AgeNowCompletedPartYear: 0,
    AgeNowCompletedPartYear_2: 0,
    EnforceMaximumContributionBase: 0,
    IncludeCoContributions: 0,
    QSuperDefaultInsuranceUnitsGovernment: 2,
    QSuperDefaultInsuranceUnitsNonGovernment: 2,
    FSSInsurancePremium: 242,
    InsurancePremium: 100,
    EquipInsurancePremium: -1,
    VisionTPD: 223.85,
    ActiveSuper_MaleDeathPerUnitPerMonth: 0.854,
    ActiveSuper_FemaleDeathPerUnitPerMonth: 0.658,
    ActiveSuper_MaleTPDPerUnitPerMonth: 0.444,
    ActiveSuper_FemaleTPDPerUnitPerMonth: 0.553,
    ActiveSuperInsuranceInflation: 0.005,
    SeniorSupplementSingle: 858.0,
    SeniorSupplementCouple: 647.4,
    SeniorSupplementIncomeThresholdSingle: 50000,
    SeniorSupplementIncomeThresholdCouple: 80000,
    Legacy603CalculationMethod: false,
    VisionIPSalaryThreshold: 0,
    VisionIncomeProtection: {
        startAge: 16,
        cost: [
            0.2,
            0.2,
            0.2,
            0.2,
            0.22,
            0.22,
            0.22,
            0.22,
            0.22,
            0.24,
            0.24,
            0.24,
            0.24,
            0.24,
            0.25,
            0.25,
            0.25,
            0.25,
            0.25,
            0.33,
            0.33,
            0.33,
            0.33,
            0.33,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.82,
            0.82,
            0.82,
            0.82,
            0.82,
            1.15,
            1.15,
            1.15,
            1.15,
            1.15,
            1.8,
            1.8,
            1.8,
            1.8,
            1.8,
            1.82,
            1.82,
            1.82,
            1.82,
            1.82,
            1.82
        ]
    },
    Output: true,
    Testing: false,
    Debug: false,
    CalculationDate: "30/06/2022",
    IncludePartner: false,
    IncludeAgePension: true,
    IncludeTTR: false,
    PriceInflationIndex: [0.04],
    WageInflationIndex: [0.04],
    SunSuperTargetIncomeInflationInRetirement: 0.03,
    AgePensionAllowCouplePensions: false,
    HomeOwner: false,
    Married: false,
    OtherAssets: 0,
    OtherIncome: 0,
    EnforceMinimumDrawingRequirements: false,
    AccountType: 1,
    AccruedDBMultiple: 0,
    AccumulationMemberCoreContributionRate: 0,
    AgeNow: 35,
    DBMemberCoreContributionRate: 0,
    UseSpecificDBAccrualRates: false,
    DeferredRetirementBalance: 0,
    EmployerContributionRate: 0.1,
    InitialExternalPension: 0,
    InvestmentOption: 3,
    InvestmentOptionInRetirement: 3,
    MemberType: 0,
    OneOffContribution: 0,
    OneOffContributionMadeAtAge: 35,
    PartTimeWorkDaysPerWeek: 0,
    PartTimeWorkFromAge: 35,
    PartTimeWorkYearsDuration: 0,
    PostTaxContributions: true,
    PostTaxMemberContributions: 0,
    PreTaxMemberContributions: 0,
    RetirementAge: 65,
    RollOverAmount: 0,
    RollOverAge: 0,
    Salary: 50000,
    Sex: "Male",
    SuperannuationBalance: 0,
    WithdrawalAtRetirement: 0,
    FutureYearsCurrentEmployment: 0,
    ContributionRateSubsequentEmployment: 0,
    AccountType_2: 1,
    AccruedDBMultiple_2: 0,
    AccumulationMemberCoreContributionRate_2: 0,
    AgeNow_2: 35,
    DBMemberCoreContributionRate_2: 0,
    UseSpecificDBAccrualRates_2: false,
    DeferredRetirementBalance_2: 0,
    EmployerContributionRate_2: 0.1,
    InitialExternalPension_2: 0,
    InvestmentOption_2: 3,
    InvestmentOptionInRetirement_2: 3,
    MemberType_2: 0,
    OneOffContribution_2: 0,
    OneOffContributionMadeAtAge_2: 0,
    PartTimeWorkDaysPerWeek_2: 0,
    PartTimeWorkFromAge_2: 0,
    PartTimeWorkYearsDuration_2: 0,
    PostTaxContributions_2: true,
    PostTaxMemberContributions_2: 0,
    PreTaxMemberContributions_2: 0,
    RetirementAge_2: 65,
    RollOverAmount_2: 0,
    RollOverAge_2: 0,
    Salary_2: 10000,
    Sex_2: "Male",
    SuperannuationBalance_2: 0,
    WithdrawalAtRetirement_2: 0,
    FutureYearsCurrentEmployment_2: 0,
    ContributionRateSubsequentEmployment_2: 0,
    AbsLifeTable: {
        startAge: 0,
        male: [
            84.73,
            84.16,
            83.18,
            82.18,
            81.18,
            80.18,
            79.17,
            78.16,
            77.15,
            76.14,
            75.13,
            74.12,
            73.1,
            72.09,
            71.07,
            70.06,
            69.05,
            68.04,
            67.04,
            66.05,
            65.06,
            64.08,
            63.1,
            62.11,
            61.12,
            60.14,
            59.15,
            58.17,
            57.18,
            56.2,
            55.21,
            54.22,
            53.23,
            52.25,
            51.25,
            50.26,
            49.27,
            48.27,
            47.28,
            46.28,
            45.28,
            44.28,
            43.28,
            42.27,
            41.27,
            40.27,
            39.27,
            38.26,
            37.26,
            36.26,
            35.26,
            34.26,
            33.26,
            32.27,
            31.27,
            30.28,
            29.29,
            28.3,
            27.32,
            26.35,
            25.38,
            24.42,
            23.47,
            22.53,
            21.6,
            20.68,
            19.77,
            18.88,
            18,
            17.14,
            16.29,
            15.46,
            14.65,
            13.86,
            13.09,
            12.34,
            11.62,
            10.92,
            10.25,
            9.61,
            8.99,
            8.4,
            7.83,
            7.3,
            6.81,
            6.35,
            5.9,
            5.48,
            5.1,
            4.75,
            4.45,
            4.18,
            3.96,
            3.76,
            3.61,
            3.48,
            3.38,
            3.3,
            3.23,
            3.18,
            3.14
        ],
        female: [
            87.85,
            87.22,
            86.24,
            85.25,
            84.26,
            83.26,
            82.26,
            81.26,
            80.26,
            79.26,
            78.26,
            77.24,
            76.24,
            75.24,
            74.24,
            73.23,
            72.23,
            71.24,
            70.24,
            69.24,
            68.25,
            67.25,
            66.26,
            65.26,
            64.27,
            63.27,
            62.27,
            61.27,
            60.28,
            59.28,
            58.28,
            57.28,
            56.28,
            55.28,
            54.28,
            53.28,
            52.28,
            51.28,
            50.28,
            49.28,
            48.28,
            47.28,
            46.29,
            45.29,
            44.29,
            43.29,
            42.29,
            41.29,
            40.3,
            39.3,
            38.3,
            37.3,
            36.31,
            35.32,
            34.32,
            33.33,
            32.34,
            31.36,
            30.38,
            29.4,
            28.43,
            27.46,
            26.5,
            25.54,
            24.59,
            23.65,
            22.71,
            21.78,
            20.85,
            19.93,
            19.03,
            18.13,
            17.25,
            16.38,
            15.52,
            14.68,
            13.86,
            13.06,
            12.28,
            11.53,
            10.8,
            10.09,
            9.42,
            8.78,
            8.16,
            7.58,
            7.04,
            6.53,
            6.05,
            5.62,
            5.22,
            4.87,
            4.55,
            4.27,
            4.04,
            3.84,
            3.68,
            3.58,
            3.51,
            3.47,
            3.46
        ]
    },
    AlternateLifeTable: {
        startAge: 50,
        male: [
            31.43,
            30.53,
            29.63,
            28.73,
            27.84,
            26.95,
            26.08,
            25.2,
            24.34,
            23.48,
            22.63,
            21.79,
            20.96,
            20.14,
            19.34,
            18.54,
            17.76,
            16.99,
            16.24,
            15.49,
            14.76,
            14.04,
            13.33,
            12.64,
            11.96,
            11.31,
            10.68,
            10.07,
            9.48,
            8.92,
            8.38,
            7.86,
            7.36,
            6.89,
            6.45,
            6.03,
            5.64,
            5.27,
            4.94,
            4.63,
            4.36,
            4.11,
            3.89,
            3.69,
            3.51,
            3.36,
            3.22,
            3.1,
            2.99,
            2.9
        ],
        female: [
            35.17,
            34.24,
            33.31,
            32.38,
            31.45,
            30.53,
            29.61,
            28.7,
            27.79,
            26.89,
            26,
            25.11,
            24.23,
            23.35,
            22.48,
            21.62,
            20.76,
            19.92,
            19.08,
            18.24,
            17.42,
            16.61,
            15.82,
            15.03,
            14.27,
            13.51,
            12.78,
            12.05,
            11.35,
            10.67,
            10.01,
            9.37,
            8.75,
            8.17,
            7.61,
            7.08,
            6.58,
            6.11,
            5.68,
            5.28,
            4.91,
            4.57,
            4.27,
            3.99,
            3.75,
            3.53,
            3.33,
            3.16,
            3,
            2.86
        ]
    },
    SunSuper_50: {
        startAge: 55,
        male: [
            32,
            31,
            30,
            29,
            28,
            27,
            26,
            25,
            24,
            23,
            22,
            21,
            20,
            19,
            18,
            17,
            16,
            15,
            14,
            13,
            13
        ],
        female: [
            35,
            34,
            33,
            32,
            31,
            30,
            29,
            28,
            27,
            26,
            24,
            23,
            22,
            21,
            20,
            19,
            18,
            17,
            16,
            15,
            14
        ]
    },
    SunSuper_10: {
        startAge: 55,
        male: [
            42,
            41,
            40,
            39,
            38,
            37,
            36,
            35,
            34,
            33,
            32,
            31,
            30,
            29,
            28,
            27,
            26,
            25,
            24,
            23,
            22
        ],
        female: [
            44,
            43,
            42,
            41,
            40,
            39,
            38,
            37,
            36,
            34,
            33,
            32,
            31,
            30,
            29,
            28,
            27,
            26,
            25,
            24,
            23
        ]
    },
    EmployerAccrualTable: {
        rate_1: {
            contributionRate: 0.0,
            memberType: "qsuper",
            accrualRate: 0.0
        },
        rate_2: {
            contributionRate: 0.01,
            memberType: "qsuper",
            accrualRate: 0.0
        },
        rate_3: {
            contributionRate: 0.02,
            memberType: "qsuper",
            accrualRate: 0.135
        },
        rate_4: {
            contributionRate: 0.03,
            memberType: "qsuper",
            accrualRate: 0.16
        },
        rate_5: {
            contributionRate: 0.04,
            memberType: "qsuper",
            accrualRate: 0.185
        },
        rate_6: {
            contributionRate: 0.05,
            memberType: "qsuper",
            accrualRate: 0.21
        },
        rate_7: {
            contributionRate: 0.0,
            memberType: "qpolice",
            accrualRate: 0.0
        },
        rate_8: {
            contributionRate: 0.01,
            memberType: "qpolice",
            accrualRate: 0.0
        },
        rate_9: {
            contributionRate: 0.02,
            memberType: "qpolice",
            accrualRate: 0.0
        },
        rate_10: {
            contributionRate: 0.03,
            memberType: "qpolice",
            accrualRate: 0.14
        },
        rate_11: {
            contributionRate: 0.04,
            memberType: "qpolice",
            accrualRate: 0.175
        },
        rate_12: {
            contributionRate: 0.05,
            memberType: "qpolice",
            accrualRate: 0.21
        },
        rate_13: {
            contributionRate: 0.06,
            memberType: "qpolice",
            accrualRate: 0.245
        },
        rate_14: {
            contributionRate: 0.0,
            memberType: "AGEST",
            accrualRate: 0.0
        },
        rate_15: {
            contributionRate: 0.01,
            memberType: "AGEST",
            accrualRate: 0.0
        },
        rate_16: {
            contributionRate: 0.02,
            memberType: "AGEST",
            accrualRate: 0.0
        },
        rate_17: {
            contributionRate: 0.03,
            memberType: "AGEST",
            accrualRate: 0.0
        },
        rate_18: {
            contributionRate: 0.04,
            memberType: "AGEST",
            accrualRate: 0.0
        },
        rate_19: {
            contributionRate: 0.05,
            memberType: "AGEST",
            accrualRate: 0.0
        },
        rate_20: {
            contributionRate: 0.06,
            memberType: "AGEST",
            accrualRate: 0.0
        },
        rate_21: {
            contributionRate: 0.07,
            memberType: "AGEST",
            accrualRate: 0.0
        },
        rate_22: {
            contributionRate: 0.08,
            memberType: "AGEST",
            accrualRate: 0.0
        },
        rate_23: {
            contributionRate: 0.09,
            memberType: "AGEST",
            accrualRate: 0.0
        },
        rate_24: {
            contributionRate: 0.1,
            memberType: "AGEST",
            accrualRate: 0.0
        }
    },
    EmployerContributionTable: {
        rate_1: {
            contributionRate: 0.0,
            memberType: "qsuper",
            accumulationContributionRate: 0.09
        },
        rate_2: {
            contributionRate: 0.01,
            memberType: "qsuper",
            accumulationContributionRate: 0.0
        },
        rate_3: {
            contributionRate: 0.02,
            memberType: "qsuper",
            accumulationContributionRate: 0.0975
        },
        rate_4: {
            contributionRate: 0.03,
            memberType: "qsuper",
            accumulationContributionRate: 0.1075
        },
        rate_5: {
            contributionRate: 0.04,
            memberType: "qsuper",
            accumulationContributionRate: 0.1175
        },
        rate_6: {
            contributionRate: 0.05,
            memberType: "qsuper",
            accumulationContributionRate: 0.1275
        },
        rate_7: {
            contributionRate: 0.0,
            memberType: "qpolice",
            accumulationContributionRate: 0.09
        },
        rate_8: {
            contributionRate: 0.01,
            memberType: "qpolice",
            accumulationContributionRate: 0.0
        },
        rate_9: {
            contributionRate: 0.02,
            memberType: "qpolice",
            accumulationContributionRate: 0.0
        },
        rate_10: {
            contributionRate: 0.03,
            memberType: "qpolice",
            accumulationContributionRate: 0.12
        },
        rate_11: {
            contributionRate: 0.04,
            memberType: "qpolice",
            accumulationContributionRate: 0.14
        },
        rate_12: {
            contributionRate: 0.05,
            memberType: "qpolice",
            accumulationContributionRate: 0.16
        },
        rate_13: {
            contributionRate: 0.06,
            memberType: "qpolice",
            accumulationContributionRate: 0.18
        }
    },
    GovernmentIncomeProtectionTable: {
        startAge: 16,
        cost: [
            0.00275,
            0.00276,
            0.0028,
            0.00287,
            0.00299,
            0.00306,
            0.00321,
            0.00343,
            0.00364,
            0.0039,
            0.00412,
            0.00437,
            0.00464,
            0.00488,
            0.00512,
            0.00553,
            0.00589,
            0.00636,
            0.00687,
            0.0074,
            0.00782,
            0.00835,
            0.00886,
            0.0093,
            0.00965,
            0.01015,
            0.01048,
            0.01078,
            0.01107,
            0.01143,
            0.01181,
            0.01215,
            0.01241,
            0.0129,
            0.01336,
            0.01395,
            0.01463,
            0.01551,
            0.01617,
            0.01711,
            0.01805,
            0.01927,
            0.02043,
            0.02214,
            0.02359,
            0.02578,
            0.02733,
            0.02705,
            0.01482,
            0
        ]
    },
    PoliceIncomeProtectionTable: {
        startAge: 16,
        cost: [
            0.00071,
            0.00072,
            0.00073,
            0.00075,
            0.00078,
            0.00079,
            0.00083,
            0.00086,
            0.00089,
            0.00094,
            0.00099,
            0.00103,
            0.00109,
            0.00116,
            0.00119,
            0.00129,
            0.0014,
            0.0015,
            0.00161,
            0.00171,
            0.00182,
            0.00191,
            0.00202,
            0.00211,
            0.00222,
            0.0023,
            0.00241,
            0.00253,
            0.00265,
            0.00276,
            0.00293,
            0.00307,
            0.00317,
            0.00329,
            0.00342,
            0.00363,
            0.0038,
            0.00403,
            0.00431,
            0.00457,
            0.00479,
            0.00516,
            0.00391,
            0.00051,
            0
        ]
    },
    NonGovernmentIncomeProtectionTable: {
        startAge: 16,
        cost: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    SunSuperDeathTPDMale: {
        startAge: 15,
        cost: [
            2.0,
            2.0,
            2.0,
            2.0,
            2.0,
            2.0,
            2.0,
            3.52,
            3.52,
            3.52,
            3.52,
            3.52,
            3.52,
            3.52,
            3.52,
            6.4,
            6.4,
            6.4,
            6.4,
            6.4,
            6.4,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            3.96,
            3.96,
            3.96
        ]
    },
    SunSuperDeathTPDFemale: {
        startAge: 15,
        cost: [
            1.2,
            1.2,
            1.2,
            1.2,
            1.2,
            1.2,
            1.2,
            2.36,
            2.36,
            2.36,
            2.36,
            2.36,
            2.36,
            2.36,
            2.36,
            4.32,
            4.32,
            4.32,
            4.32,
            4.32,
            4.32,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            2.56,
            2.56,
            2.56
        ]
    },
    QSuperDeathTPDDefault: {
        startAge: 16,
        cost: [
            0.56,
            0.55,
            0.56,
            0.58,
            0.61,
            0.67,
            0.76,
            0.89,
            1.06,
            1.26,
            1.48,
            1.75,
            2.04,
            2.36,
            2.68,
            2.98,
            3.3,
            3.62,
            3.95,
            4.32,
            4.7,
            5.13,
            5.58,
            6.01,
            6.43,
            6.63,
            6.64,
            6.65,
            6.65,
            6.65,
            6.66,
            6.66,
            6.66,
            6.66,
            6.51,
            6.27,
            6.02,
            5.74,
            5.51,
            5.24,
            4.87,
            4.41,
            3.89,
            3.45,
            3.05,
            2.68,
            2.45,
            2.37,
            0.55,
            0.59,
            0.65,
            0.7,
            0.76,
            0.82
        ]
    },
    QSuperDeathTPDPolice: {
        startAge: 16,
        cost: [
            0.88,
            0.88,
            0.9,
            0.93,
            0.98,
            1.06,
            1.21,
            1.42,
            1.68,
            2.01,
            2.36,
            2.78,
            3.27,
            3.76,
            4.28,
            4.77,
            5.27,
            5.78,
            6.31,
            6.91,
            7.51,
            8.2,
            8.93,
            9.62,
            10.29,
            10.6,
            10.61,
            10.63,
            10.64,
            10.64,
            10.64,
            10.65,
            10.64,
            10.64,
            10.43,
            10.04,
            9.62,
            9.18,
            8.81,
            8.37,
            7.78,
            7.06,
            6.23,
            5.52,
            0,
            0
        ]
    },
    InTodaysTerms: true,
    EquipDeathPremiums: {
        startAge: 0,
        cost: []
    },
    EquipTPDPremiums: {
        startAge: 0,
        cost: []
    },
    EquipDeathCoverTaper: {
        startAge: 0,
        cost: []
    },
    EquipTPDCoverTaper: {
        startAge: 0,
        cost: []
    },
    EquipInsurancePremiumSteps: {
        startAge: 0,
        cost: []
    }
};
//# sourceMappingURL=defaults.js.map